import {
  HIDE_INVOICE_LIST_LOADER,
  SET_ERROR_INVOICE_PROFILE,
  SET_INVOICE_PROFILE,
  SET_INVOICES_LIST,
  SET_INVOICE_CHOICE,
  SHOW_INVOICE_LIST_LOADER,
  SET_STATUSES,
  INVOICE_PROFILE_LOADER,
  INVOICE_MAKE_LOADER,
  SET_INVOICES_FILTER_DATA,
  SET_AGGREGATED_STAFF_DATA,
  LOADER_AGGREGATED_STAFF_DATA
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
    date_filters: {},
  },
  filter_data: {
    contractors: [],
    bank_account_numbers: [],
    currencies: [],
  },
  staffData: {},
  staffLoaderData: false,
  statuses: [],
  choices: {},
  profileData: {},
  profileLoader: false,
  profileMakeLoader: false,
  isError: false,
  loading: false,
  error: null,
};

const InvoiceList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_INVOICES_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SET_INVOICE_CHOICE:
      return {
        ...state,
        choices: action.payload,
      };
    case SHOW_INVOICE_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_INVOICE_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_INVOICE_PROFILE:
      return {
        ...state,
        profileData: action.payload,
      };
    case SET_ERROR_INVOICE_PROFILE:
      return {
        ...state,
        isError: action.payload,
      };
    case SET_STATUSES:
      return {
        ...state,
        statuses: action.payload,
      };
    case INVOICE_PROFILE_LOADER:
      return {
        ...state,
        profileLoader: !state.profileLoader,
      };
    case INVOICE_MAKE_LOADER:
      return {
        ...state,
        profileMakeLoader: !state.profileMakeLoader,
      };
    case SET_INVOICES_FILTER_DATA:
      return {
        ...state,
        filter_data: action.payload,
      };
    case SET_AGGREGATED_STAFF_DATA: {
      return {
        ...state,
        staffData: action.payload,
      };
    }
    case LOADER_AGGREGATED_STAFF_DATA: {
      return {
        ...state,
        staffLoaderData: !state.staffLoaderData,
      };
    }
    default:
      return state;
  }
};

export default InvoiceList;
